"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../../Text"));
var _Theme = _interopRequireDefault(require("../../Theme"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _MobileDropdownOption = _interopRequireDefault(require("./MobileDropdownOption.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var OptionContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileDropDownOption__OptionContainer",
  componentId: "sc-13smo19-0"
})(["position:relative;display:flex;align-items:center;box-sizing:border-box;height:50px;", ";justify-content:space-between;", ";cursor:pointer;"], function (_ref) {
  var theme = _ref.theme,
    separator = _ref.separator;
  return separator ? "border-bottom: 1px solid ".concat(theme.colors.greyLight) : "none";
}, function (_ref2) {
  var theme = _ref2.theme,
    itemSelected = _ref2.itemSelected;
  return itemSelected ? "background-color: ".concat(theme.colors.greyLighter) : "background-color: transparent";
});
var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileDropDownOption__TextWrapper",
  componentId: "sc-13smo19-1"
})(["display:inline-flex;"]);
var PrimaryLabelWrapper = (0, _styledComponents.default)(TextWrapper).withConfig({
  displayName: "MobileDropDownOption__PrimaryLabelWrapper",
  componentId: "sc-13smo19-2"
})(["padding-right:", ";padding-left:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.normal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.normal;
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileDropDownOption__IconWrapper",
  componentId: "sc-13smo19-3"
})(["margin-top:", ";padding-right:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.mini;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.normal;
});
var MobileDropdownOption = function MobileDropdownOption(props) {
  var itemSelected = props.itemSelected,
    title = props.title,
    subtitle = props.subtitle,
    value = props.value,
    icon = props.icon,
    theme = props.theme,
    titleColor = props.titleColor,
    subtitleColor = props.subtitleColor,
    bold = props.bold,
    separator = props.separator,
    onOptionPress = props.onOptionPress,
    iconColor = props.iconColor,
    customProperties = props.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(OptionContainer, (0, _extends2.default)({
      onClick: function onClick() {
        return onOptionPress(value);
      },
      separator: separator
    }, customProperties, {
      itemSelected: itemSelected
    }), /*#__PURE__*/_react.default.createElement(TextWrapper, null, /*#__PURE__*/_react.default.createElement(PrimaryLabelWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: themeContext,
      color: titleColor,
      bold: bold
    }, title)), subtitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: themeContext,
      color: subtitleColor,
      bold: bold
    }, subtitle)), itemSelected && /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: icon,
      color: iconColor,
      fontsize: _constant.ICON.SIZE,
      theme: themeContext
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
MobileDropdownOption.propTypes = _MobileDropdownOption.default.PropTypes;
MobileDropdownOption.defaultProps = _MobileDropdownOption.default.DefaultProps;
var _default = MobileDropdownOption;
exports.default = _default;